import { useState, useEffect, useContext } from "react"
import { useParams, useHistory, useLocation } from "react-router-dom";
import { Card, CardBody, CardHeader, CardTitle, CardText, ListGroup, ListGroupItem, Row, Col, Button, Input, Label } from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader";
import SettingsManagementService from "core/api/SettingsManagementService";
import { CrudDropdownEditDelete } from "views/Shared/CrudDropdownEditDelete";
import { getDisplayValue } from "./SettingFunctions";


const View = () => {
    const { id } = useParams();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    const history = useHistory();


    useEffect(() => {
        async function fetchData() {
            const setting = await SettingsManagementService.get(id);

            setData(setting);

            setLoading(false);
        }
        fetchData();
    }, [])

    if (loading) return <>Loading</>;
    return (
        <>
            <PanelHeader
                content={
                    <div className="header text-center">
                        <h1 className="title">
                            Setting
                        </h1>
                        <h2 className="title">
                            {data?.displayName}
                        </h2>
                    </div>
                }
            />
            <div className="content">
                <Row>
                    <Col xs={12} md={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <CardTitle tag="h4">Setting Information</CardTitle>
                                <Col xs="auto">
                                    <CrudDropdownEditDelete
                                        id={id}
                                        onDelete={() => {
                                            SettingsManagementService.delete(id);
                                            history.goBack();
                                        }}
                                        deletePermissions={["all:settingsManagement", "delete:settingsManagement"]}
                                        editPermissions={["all:settingsManagement", "write:settingsManagement", "admin"]}
                                    />
                                </Col>
                            </CardHeader>
                            <CardBody>
                                <ListGroup >
                                    <ListGroupItem>
                                        <strong>Name:</strong> {data?.displayName}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Value:</strong> {getDisplayValue(data?.value, data?.dataType)}
                                    </ListGroupItem>
                                    <ListGroupItem>
                                        <strong>Notes:</strong> {data?.notes}
                                    </ListGroupItem>

                                </ListGroup>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >

        </>
    )
}

export default View